import React from "react";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { saveAs } from "file-saver";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["custom-file-input"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

const downloadFile = (file_path, file_name) => {
  let base_url = 'https://central.ccdemostore.com/uploads/banners/';

  saveAs(base_url + file_path, file_name)
}

export function FileInput({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  ...props
}) {
  return (
    <>
      {label && <label className="col-xl-3 col-lg-2 col-form-label text-right">{label}</label>}
      <div className="col-lg-6 col-xl-6">
        <div className="custom-file" style={{ zIndex: "0" }}>
          <input
            type={type}
            className={getFieldCSSClasses(touched[field.name], errors[field.name])}
            {...field}
            {...props}
          />
          {withFeedbackLabel && (
            <FieldFeedbackLabel
              error={errors[field.name]}
              touched={touched[field.name]}
              label={label}
              type={type}
              customFeedbackLabel={customFeedbackLabel}
            />
          )}
          <label className="custom-file-label" htmlFor="inputGroupFile01">
            {props.filename}
          </label>
        </div>
        {props.helpertext ? <p className="mt-2">* Supported Formats are JPG, JPEG, PNG </p> : <p className="mt-2">* Supported Formats are JPG, JPEG, PNG, ZIP </p>}
        {props.isLoading &&
          <div className="spinner spinner-track spinner-primary spinner-lg mr-15">
            <span className="ml-10">Uploading</span>
          </div>
        }

        {props.bannerId !== undefined && props.bannerInfo?.banner_file &&
          < button type="button" className="btn btn-light-info btn-sm" title={props.bannerInfo.banner_file} onClick={() => downloadFile(props.bannerInfo.banner_file, props.bannerInfo.banner_file)}>Download File</button>
        }
      </div>
    </>
  );
}
